import React from 'react';

import { Col as AntdCol, Row as AntdRow } from 'antd';

import './SuiviVehiculeMainInfoDetail.less';

interface SuiviVehiculeMainInfoDetailProps {
  label: string;
  children: React.ReactElement;
}

export const SuiviVehiculeMainInfoDetail = ({
  label,
  children,
}: SuiviVehiculeMainInfoDetailProps): React.ReactElement => {
  const LABEL_COL_SPAN = 10;
  const ROW_GUTTER = 10;
  const COL_CLASS_NAME = 'label-col';

  return (
    <AntdRow gutter={ROW_GUTTER}>
      <AntdCol className={COL_CLASS_NAME} span={LABEL_COL_SPAN}>
        <span className="label">{label}</span>
      </AntdCol>
      <AntdCol className={COL_CLASS_NAME}>{children}</AntdCol>
    </AntdRow>
  );
};
